import React, { useCallback } from "react";
import { ActionButton, Button, Thumbnail } from "@culturehq/components";

import { ProfileLink } from "app/links";
import { t, Trans } from "app/utils";

import UserSearch from "components/UserSearch";

import getUserName from "app/utils/getUserName";
import styles from "./styles.module.scss";

const RecognizeUser = ({ onUserDeselected, user }) => {
  const onClick = useCallback(() => onUserDeselected(user), [onUserDeselected, user]);

  return (
    <>
      <ProfileLink user={user}>
        <Thumbnail image={user.avatar.thumbUrl} />
        {" "}
        {getUserName(user)}
      </ProfileLink>
      {" "}
      <ActionButton icon="trash-a" onClick={onClick} />
    </>
  );
};

const RecognizeSelectUsers = ({ users, onUserSelected, onUserDeselected, onNextClicked }) => (
  <>
    <h1>
      <Trans>Which user(s) would you like to recognize?</Trans>
    </h1>
    <UserSearch
      autoFocus
      excludeIds={users.map(user => user.id)}
      onUserSelected={onUserSelected}
      placeholder={t("Search and choose one or more people to recognize")}
    />
    {users.length > 0 && (
      <div className="recognize__users">
        {users.map(user => (
          <RecognizeUser key={user.id} user={user} onUserDeselected={onUserDeselected} />
        ))}
      </div>
    )}
    <Button primary disabled={users.length === 0} onClick={onNextClicked}>
      <Trans>Next</Trans>
    </Button>
    <p className={styles.help}>
      <Trans>Next: Choose the type of recognition you want to give</Trans>
    </p>
  </>
);

export default RecognizeSelectUsers;
